import React from 'react';
import { Controller, Control } from 'react-hook-form';
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { ChallengeFormData } from '../types';
import { labelStyle } from '../utils';

interface ReviewStepProps {
  control: Control<ChallengeFormData>;
}

const ReviewStep = ({ control }): ReviewStepProps => {
  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <p>Challenge Status *</p>
        <Typography style={labelStyle}>
          Take time to review the information you entered. The challenge can be published only when
          all required fields have been completed. Published challenges will be visible in the
          Employee app on the Challenge Start Date.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl component="fieldset" style={{ marginTop: 8 }}>
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <RadioGroup {...field} row>
                    <Tooltip title="Draft challenges can be edited freely">
                      <FormControlLabel value="draft" control={<Radio />} label="Draft" />
                    </Tooltip>
                    <Tooltip title="Published challenges will be visible in the Employee app after the Challenge Start Date">
                      <FormControlLabel value="published" control={<Radio />} label="Published" />
                    </Tooltip>
                  </RadioGroup>
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ReviewStep;
